import HmEventRegistry from './../model/HmEventRegistry';
import Constants from './../config/constants.json';

/**
* This function is specific to FB Pixel Campaign, triggered by AdsTracker based on
* associated AD id in public/maintenance.js.
*/
var FbCampaignTrack = function(){
	
	let pixelCode = Constants["fb_pixel_id"];
	
	let isTrackerReady = false;

	let isDocumentLoaded = function(){
		return (window.document) ? true : false;
	};
	

	var associateCode = function(callBack){
		if(!isTrackerReady){
			
			const FB_TIME_CHECK_REPEAT = 8;
			let fbChecked = 0; 

			var fbTimeCheck = setInterval(() => {
				fbChecked++;

				if(fbChecked >= FB_TIME_CHECK_REPEAT){
					clearInterval(fbTimeCheck);
				}

				if(isDocumentLoaded()){
					if(document){
						try{
							const existingScript = document.getElementById('fb-pixel');

							if (!existingScript) {
								const fbPixelScript = document.createElement('script');
								fbPixelScript.type = 'text/javascript';
								fbPixelScript.id = 'fb-pixel';
								fbPixelScript.async = true;
								fbPixelScript.innerHTML = "!function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window,document,'script', 'https://connect.facebook.net/en_US/fbevents.js');";

								document.body.appendChild(fbPixelScript);

								isTrackerReady = true;
								console.log("Pixel_track initiated.");
								if(typeof callBack === "function"){
									console.log("Pixel callback applied");
									callBack.apply(this);
								}

							}
						}catch(e){}finally{
							clearInterval(fbTimeCheck);
						}
					}
				}
			},500);

		}else{
			console.log("Pixel_track initiated.");
			if(typeof callBack === "function"){
				console.log("Pixel callback applied");
				callBack.apply(this);
			}

		}
	}
	

	return{
		track: function(trackObj){
			let prefix = (trackObj && trackObj.prefix) ? trackObj.prefix : "";


			if(trackObj && trackObj.eventName){
				let pxlCode = (trackObj.pixelCode) ? trackObj.pixelCode : pixelCode;
				let eventType = (trackObj.eventType) ? trackObj.eventType : 'trackCustom';

				if(isTrackerReady && window.fbq){
					console.log("Pixel triggering direct");
					window.fbq(eventType, prefix + trackObj.eventName);
				}else{
					associateCode(() => {
						console.log("Pixel triggering callback ");
						window.fbq('init', pxlCode); 
						window.fbq(eventType, prefix + trackObj.eventName);
					});
				}	
			}else{
				console.warn("eventName has not been provided.");
			}
		}
	};
}();

export default FbCampaignTrack;

/**
* Register FB Campaign as HMevent
*/
HmEventRegistry.registerEvent("TRACKER_FACEBOOK",function([trackObj]){
	if(!trackObj){
		trackObj = {};
	}

	trackObj["prefix"] = "fb-";

	FbCampaignTrack.track(trackObj);
});

/**
* Register INstagram Campaign as HMevent
*/
HmEventRegistry.registerEvent("TRACKER_INSTAGRAM",function([trackObj]){
	if(!trackObj){
		trackObj = {};
	}

	trackObj["prefix"] = "ig-";

	FbCampaignTrack.track(trackObj);
});


/**
* Register Centa Campaign as HMevent
*/
HmEventRegistry.registerEvent("TRACKER_CENTA",function([trackObj]){
	if(!trackObj){
		trackObj = {};
	}

	trackObj["prefix"] = "centa-";

	FbCampaignTrack.track(trackObj);
});



// WEBPACK FOOTER //
// ./src/vendors/FbCampaignTrack.js